/**
 * @license
 * Copyright (c) 2021 Entelechy Corporation. All rights reserved.
 */

import { css, html } from "lit"
import { customElement, property } from 'lit/decorators.js'
import { ECComponent } from "./ec-component"

@customElement('ec-footer')
export class ECFooter extends ECComponent {
  /**
   * True iff the application bar should be visible.
   */
  @property({type: String })
  show = 'true';

  static styles = [
    ...ECComponent.styles,
    css`
      div.footer {
        display: flex;
        width: 100%;
        background-color: var(--title-bar-bgcolor);
        color: var(--dark-fg);
        align-items: center;
        box-sizing: border-box; /* include padding as content, preventing content overflow for 100% height/width settings */
        padding-top: 0.25em;
        padding-bottom: 0.25em;
        font-size: 0.75rem;
      }
      .copyright {
        flex-grow: 1;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        
        vertical-align: middle;
        padding-left: 0.25em;
        margin-left: 1em;
      }
      .policy {
        flex-grow: 3;
        display: flex;
        justify-content: right;
        align-items: right;
        
        vertical-align: middle;
      }
      .policy-item {
        margin-left: 1em;
        margin-right: 1em;
      }
      .short-text {
        display: none;
      }
      @media (max-width: 500px) {
        .short-text { display: inline-block; }
        .full-text { display: none; }
      }
    `
  ]

  render() {
    return html`
      <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet"/>
      <div class="footer">
      <div class="copyright full-text">© 2023 Entelechy Corporation</div>
      <div class="copyright short-text">© 2023 Entelechy</div>
        <div class="policy">
          <span class="policy-item full-text">Terms of Use</span>
          <span class="policy-item short-text">Terms</span>
          <span>|</span>
          <span class="policy-item full-text">Privacy Policy</span>
          <span class="policy-item short-text">Privacy</span>
          <span>|</span>
          <span class="policy-item full-text">Cookie Policy</span>
          <span class="policy-item short-text">Cookies</span>
        </div>
      </div>
    `;
  }
}
